module.exports = __webpack_public_path__ + "img/popup_aviso_pagos_sharf.03879191.png";